import React, { useState } from "react";
import { Table } from "reactstrap";
// componentes
import ModalEditTransfer from "./ModalEditTransfer";
import DeleteButton from "../../../components/Buttons/DeleteButton";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// service
import { deleteTransfer } from "../../../utils/services/transfer";

export default function TableTransfer(props) {
  const { transfer, idEvent, data, participants } = props;
  const [transferSelected, setTransferSelected] = useState(null);
  // modal
  const [modalEditTransfer, setModalEditTransfer] = useState(false);
  // alerta
  const [alertDelete, setAlertDelete] = useState(false);
  const [alertDeleteConfirmed, setAlertDeleteConfirmed] = useState(false);

  const getValue = (item, key) => {
    if (!item) return "-"; // Verificação para item nulo ou indefinido

    if (item.registrationType !== "VEICULO") {
      if (key === "boardingdate" || key === "arrivaldate") {
        const hour = key === "boardingdate" ? "boardingtill" : "arrivaltime";
        return `${formatData(item[key])} ${item[hour]}`;
      }
      return item[key] || "-"; // Verificação para item[key] nulo ou indefinido
    }

    if (key === "boardingdate" || key === "arrivaldate") {
      const parseKey =
        key === "boardingdate" ? "departureDatetime" : "arrivalDatetime";
      if (
        !item.vehicle ||
        !item.vehicle[parseKey] ||
        item.vehicle[parseKey].includes("1969")
      )
        return "-";
      const datePart = item.vehicle[parseKey]?.split("T")[0];
      const hour = item.vehicle[parseKey]?.split("T")[1]?.substring(0, 5);
      const [year, month, day] = datePart.split("-");
      return `${day}/${month}/${year} ${hour}`;
    }

    return item?.vehicle?.[key] || "-"; // Verificação para item.vehicle[key] nulo ou indefinido
  };

  function formatData(startDate) {
    if (!startDate) return "-";
    var data = new Date(startDate + "T00:00:00-03:00");
    var dia = String(data.getDate()).padStart(2, "0");
    var mes = String(data.getMonth() + 1).padStart(2, "0");
    var ano = data.getFullYear();
    var dataAtual = dia + "/" + mes + "/" + ano;

    return dataAtual;
  }

  function checkProductExists(product) {
    if (location.state) {
      const search = location.state.event.product.filter(
        (e) => e.name === product,
      );

      if (search[0]) {
        return true;
      } else return false;
    }
  }

  async function confirmDelete() {
    await deleteTransfer({
      jwt: "",
      id: transferSelected.id,
    }).then(() => {
      setAlertDelete(false);
      setAlertDeleteConfirmed(true);
    });
    // .catch((error) => console.log("error", error));
  }

  return (
    <>
      {modalEditTransfer && (
        <ModalEditTransfer
          isOpen={modalEditTransfer}
          toggle={() => setModalEditTransfer(false)}
          idEvent={idEvent}
          editTransfer={transferSelected}
          data={data}
          participants={participants}
          transfer={transfer}
        />
      )}

      {alertDelete && (
        <SweetAlert
          title={`Deseja deletar esse Transfer?`}
          warning
          showCancel
          confirmBtnText="Sim"
          cancelBtnText="Não"
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          onConfirm={() => {
            confirmDelete();
          }}
          onCancel={() => setAlertDelete(false)}
        >
          <a>Você não poderá reverter essa ação.</a>
        </SweetAlert>
      )}

      {alertDeleteConfirmed ? (
        <SweetAlert
          success
          title={"Sucesso"}
          onConfirm={() => {
            data();
            setAlertDeleteConfirmed(false);
          }}
        >
          Transfer deletado com sucesso
        </SweetAlert>
      ) : null}

      <div className="table-responsive">
        <Table className="table mb-0">
          <thead className="table-light">
            <tr>
              <th>Participante</th>
              {checkProductExists("Inteegra MOBI") && (
                <>
                  <th>Tipo Cadastro</th>
                  <th>Nome Veículo</th>
                </>
              )}
              <th>Empresa</th>
              <th>Origem</th>
              <th>Destino</th>
              <th>Data/hora embarque</th>
              <th>Data/hora chegada</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {transfer &&
              transfer
                ?.filter((e) => e.login.nome?.toLocaleLowerCase())
                ?.map((e, i) => (
                  <tr key={i}>
                    <td>{e.login.nome}</td>
                    {checkProductExists("Inteegra MOBI") && (
                      <>
                        <td>{e.registrationType}</td>
                        <td>{e.vehicle ? e.vehicle.description : ""}</td>
                      </>
                    )}
                    <td>{getValue(e, "company")}</td>
                    <td>{getValue(e, "origin")}</td>
                    <td>{getValue(e, "destination")}</td>
                    <td>{getValue(e, "boardingdate")}</td>
                    <td>{getValue(e, "arrivaldate")}</td>
                    {/* <td>{formatData(e.criadoEm)}</td> */}
                    <td>
                      <i
                        className="mdi mdi-pencil"
                        style={{
                          color: "green",
                          fontSize: 17,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setTransferSelected(e);
                          setModalEditTransfer(true);
                        }}
                      />
                      <DeleteButton
                        onClick={() => {
                          setTransferSelected(e);
                          setAlertDelete(true);
                        }}
                      />
                      {/* <i
                        className="mdi mdi-trash-can"
                        style={{
                          color: "red",
                          fontSize: 17,
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setTransferSelected(e);
                          setAlertDelete(true);
                        }}
                      /> */}
                    </td>
                  </tr>
                ))}
          </tbody>
        </Table>
      </div>
    </>
  );
}
